import type { IconData } from '@stacksjs/iconify-core'

export const ml4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"red\" d=\"M425.8 0H640v480H425.7z\"/><path fill=\"#009a00\" d=\"M0 0h212.9v480H0z\"/><path fill=\"#ff0\" d=\"M212.9 0h214v480h-214z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ml4x3
